import React, { useContext, useCallback, useMemo } from "react";
import _ from "lodash";
import { WizardPage, wizardProps } from "@xengage/gw-portals-wizard-react";
import { ViewModelForm, withViewModelService } from "@xengage/gw-portals-viewmodel-react";
import { useValidation } from "@xengage/gw-portals-validation-react";
import { readViewModelValue } from "@xengage/gw-jutro-adapters-react";
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { PremierConstants } from "premier-constant-service";
import { useUpdateSubmissionServices, validationUtil } from "premier-capability-hooks";
import metadata from "./PropertyDetailsPage.metadata.json5";
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import PropertyDetailsComponent from "../../../components/PersonalUmbrella/Property/PropertyDetailsComponent";
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function PropertyDetailsPage(props) {
  const {
    wizardData: submissionVM,
    updateWizardData,
    viewModelService
  } = props;
  const breakpoint = useContext(BreakpointTrackerContext);
  const { onValidate, initialValidation } = useValidation(
    "PropertyDetailsPage"
  );
  const { updateSubmission } = useUpdateSubmissionServices();
  const { lineName } = PremierConstants;

  const onNext = useCallback(async () => {
    const productCode = _.get(submissionVM.value, "baseData.productCode");
    // eslint-disable-next-line security/detect-object-injection
    const lobLineName = productCode ? lineName[productCode] : "";
    const response = await updateSubmission(
      lobLineName,
      "PropertyDetailsPage",
      submissionVM
    );

    submissionVM.value = response;

    return submissionVM;
  }, [lineName, submissionVM, updateSubmission]);

  const propertyOverrides = useMemo(() => {
    const propertyArray = _.get(submissionVM, 'lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails', []);
    let overrides = [];

    if (!_.isEmpty(propertyArray)) {
      overrides = propertyArray?.children.map((property, index) => ({
        [`propertyDetailsComponent${index}`]: {
          overrideProps: {
            "@field": {
              // apply to all fields
              showRequired: true,
              labelPosition: "left",
            },
          },
          submissionVM,
          updateWizardData,
          pathUpdated: `lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails.children[${index}]`,
          propertyVM: property,
          index,
          viewModelService
        }
      }));
    }

    return Object.assign({}, ...overrides);
  }, [submissionVM, updateWizardData, viewModelService]);

  const addPersonalUmbrella = useCallback(async () => {

    const personalUmbrellaObj = {
      tempID: EntityUtil.nextId(),      
    };

    const { _xCenter, _dtoName } = submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails;

    const personalUmbrellaVM = viewModelService.create(personalUmbrellaObj, _xCenter, _dtoName);

    submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails.value = submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails.value || []

    submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails.pushElement(
      personalUmbrellaVM
    );
    updateWizardData(submissionVM);
  },
    [submissionVM, viewModelService, updateWizardData]
  );

  const onSave = useCallback(
    async () => {
      const subVMCopy = _.clone(submissionVM)
      const productCode = _.get(subVMCopy.value, 'baseData.productCode');

      validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails.value, ' ')

      const lobLineName = productCode ? lineName[productCode] : '';
      await updateSubmission(lobLineName, 'PropertyDetailsPage', subVMCopy);
                      
      return submissionVM;
    },
    [lineName, submissionVM, updateSubmission]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
    "@field": {
      showRequired: true,
      labelPosition: breakpoint === "desktop" ? "left" : "top",
    },
    ...propertyOverrides,
  };

  const resolvers = {
    resolveCallbackMap: {
      onValidate,
      addPersonalUmbrella
    },
    resolveComponentMap: {
      propertyDetailsComponent: PropertyDetailsComponent
    },
    resolveClassNameMap: styles
  };

  const readValue = useCallback(
    (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
    [submissionVM, overrideProps]
  );

  const isDisableNext = () =>
    !submissionVM.lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails
      .aspects.subtreeValid;

  return (
    <WizardPage
      onNext={onNext}
      onSave={onSave}
      skipWhen={initialValidation}
      disableNext={isDisableNext()}
    >
      <ViewModelForm
        uiProps={metadata.pageContent}
        model={submissionVM}
        onModelChange={updateWizardData}
        overrideProps={overrideProps}
        onValidationChange={onValidate}
        resolveValue={readValue}
        callbackMap={resolvers.resolveCallbackMap}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
      />
    </WizardPage>
  );
}

PropertyDetailsPage.propTypes = wizardProps;
export default withViewModelService(PropertyDetailsPage);

